import React from 'react';
import { useTranslation } from 'react-i18next';
import Plus from '@/icons/Plus';
import Upload from '@/icons/Upload';

interface OverviewEmptyHeroProps {
  isOwner: boolean;
  canUploadGedcom: boolean;
  onAddSelf: () => void;
  onUploadGedcom: () => void;
}

const OverviewEmptyHero: React.FC<OverviewEmptyHeroProps> = ({
  isOwner,
  canUploadGedcom,
  onAddSelf,
  onUploadGedcom
}) => {
  const { t } = useTranslation('overview');

  return (
    <div className="overview-empty-hero">
      <span className="overview-empty-hero__stripe" aria-hidden />
      <h2 className="overview-empty-hero__title">
        {t('emptyHero.titlePrefix')}
        <em>{t('emptyHero.titleEmphasis')}</em>
        {t('emptyHero.titleSuffix')}
      </h2>
      <p className="overview-empty-hero__body">{t('emptyHero.body')}</p>
      <div className="overview-empty-hero__cta">
        {isOwner && (
          <button type="button" className="btn btn--primary btn--lg" onClick={onAddSelf}>
            <Plus width={16} height={16} />
            {t('emptyHero.addSelf')}
          </button>
        )}
        {canUploadGedcom && (
          <button type="button" className="btn btn--ghost btn--lg" onClick={onUploadGedcom}>
            <Upload width={16} height={16} />
            {t('emptyHero.importGedcom')}
          </button>
        )}
      </div>
    </div>
  );
};

export default OverviewEmptyHero;
